import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
export const PrismaIcon = t0 => {
  const $ = _c(9);
  let className;
  let svg;
  if ($[0] !== t0) {
    ({
      className,
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = svg;
  } else {
    className = $[1];
    svg = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M18.9073 18.1582L9.55403 20.9467C9.48887 20.9665 9.41969 20.969 9.35326 20.954C9.28683 20.9391 9.22542 20.9071 9.17501 20.8613C9.12461 20.8155 9.08695 20.7575 9.0657 20.6928C9.04445 20.6281 9.04035 20.559 9.05378 20.4922L12.3958 4.35897C12.4099 4.29307 12.4443 4.23325 12.4942 4.18792C12.5441 4.1426 12.6069 4.11404 12.6739 4.10626C12.7408 4.09848 12.8085 4.11187 12.8675 4.14455C12.9264 4.17724 12.9737 4.22757 13.0025 4.28847L19.1893 17.5342C19.217 17.5931 19.2317 17.6573 19.2322 17.7224C19.2327 17.7875 19.2191 17.852 19.1922 17.9113C19.1654 17.9706 19.1261 18.0234 19.0769 18.066C19.0277 18.1087 18.9698 18.1401 18.9073 18.1582ZM20.5115 17.4997L13.3498 2.16297C13.2618 1.97381 13.1238 1.8122 12.9509 1.69552C12.7779 1.57884 12.5764 1.5115 12.368 1.50072C12.1596 1.48639 11.9514 1.52985 11.7661 1.62632C11.5808 1.72279 11.4258 1.86853 11.318 2.04747L3.55178 14.7367C3.43331 14.9288 3.3717 15.1505 3.37409 15.3762C3.37648 15.6018 3.44277 15.8222 3.56528 16.0117L7.36328 21.9435C7.5064 22.1652 7.71747 22.3345 7.96489 22.4262C8.21232 22.5178 8.48278 22.5269 8.73578 22.452L19.7608 19.1647C19.9273 19.1162 20.0813 19.0322 20.2122 18.9185C20.3432 18.8047 20.4479 18.6639 20.5192 18.5058C20.5904 18.3477 20.6266 18.176 20.6252 18.0026C20.6237 17.8292 20.5847 17.6581 20.5108 17.5012L20.5115 17.4997Z" fill="#ffffff" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== svg || $[7] !== t1) {
    t3 = <svg viewBox="0 0 24 24" fill="none" role="img" className={t1} xmlns="http://www.w3.org/2000/svg" {...svg}>{t2}</svg>;
    $[6] = svg;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
PrismaIcon.displayName = "PrismaIcon";